import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getSeasonName } from "../../helpers/seasonName";

import { setSeason, setFrameType } from "../../store/Uterum/UterumSlice";

import ReactModal from "react-modal";

import { modalStyle } from "../../components/Modal/ModalStyle";
import { useNavigate } from "react-router-dom";
import SvgComponent from "../../components/SvgComponent/SvgComponent";

import NavigateButton from "../../designComponents/NavigateButton/NavigateButton";

import { scrapePropertiesFromUrlParams } from "../../helpers/scrapePropertiesFromUrlParams";

import Card from "@mui/material/Card";

import {
  _Image as Image,
  _InspirationLink as InspirationLink,
  _InspirationHeader as InspirationHeader,
  _InspirationImageContainer as InspirationImageContainer,
} from "./ModelViewStyle";

import { _CloseButton as CloseButton } from "../../components/Tooltip/style";

import { Glyphicon } from "../../components/Glyphicon/Glyphicon";

import { getFixedConservatories, getFreeConservatories } from "./modelData";
import { Box, Grid, Typography, CardContent } from "@mui/material";

const ModelView = () => {
  const dispatch = useDispatch();

  const init = useSelector(state => state.init || {});
  const Uterum = useSelector(state => state.Uterum || {});

  useEffect(() => {
    const propertiesFromUrlParams = scrapePropertiesFromUrlParams();
    
    if (propertiesFromUrlParams?.Season) {
      dispatch(setSeason(propertiesFromUrlParams.Season));
    }
  }), [dispatch];
  
  

  const { baseRoute, alias } = init;

  const [modalIsOpen, setModalIsOpen] = React.useState(false);
  const [inspirationUterum, setInspirationUterum] = React.useState({
    images: [],
  });

  const navigate = useNavigate();

  // On mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [dispatch]);

  function openModal(uterum) {
    setInspirationUterum(uterum);
    setModalIsOpen(true);
  }

  function closeModal() {
    setModalIsOpen(false);
  }

  function listConservatories(conservatories) {
    return conservatories.map(function (conservatory) {
      if (Uterum.Season === "ISOMAX" && conservatory.value === "LYCKA") {
        // Intercept array and remove uterooms that are unavailable
        // Currently just LYCKA ISOMAX
        conservatory.availableWithConfig = false;
      }

      const {
        value,
        availableWithConfig,
        name,
        url,
        description,
        imagelistAlias,
      } = conservatory;

      return (
        <Grid key={value} item xs={12} sm={6} md={4} lg={3}>
          <Card>
            <CardContent sx={
          {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            boxSizing: 'border-box',
            height: 'calc(100% - 261px)',
            position: 'relative',
            '&:last-child': { pb: 2 }
          }
        }>
              <Image
                src={url}
                style={{
                  filter: availableWithConfig ? "none" : "grayscale() opacity(50%)",
                }}
              ></Image>

              <Typography variant="h4">{name}</Typography>

              {availableWithConfig
                ? description
                  : <Typography variant="body2">{alias.bfcNotAvailableWithSeasonChoice}</Typography>}
                
              {/* Button design component for consistent design and functionality */}
              <NavigateButton
                handleClick={() => {
                  dispatch(setFrameType(value));
                  navigate(`../${baseRoute}/step3`);
                }}
                dataId={`Card_${value}__NavigateButton`}
                text={alias.bfcChoose}
                ariaLabel={`${alias.bfcChoose} ${name}`}
                widthOnDesktop="100%"
                isDisabled={!availableWithConfig}
                // TODO @MH ska detta vara kvar?
                style={{ alignSelf: "bottom" }}
              />
              {imagelistAlias &&
                alias.hasOwnProperty(imagelistAlias) &&
                alias[conservatory.imagelistAlias].length > 0 && (
                  <InspirationLink onClick={() => openModal(conservatory)}>
                    <span>{alias.bfcInspirationPics} </span>
                    <SvgComponent name="moreImages" />
                  </InspirationLink>
                )}
            </CardContent>
          </Card>
        </Grid>
      );
    });
  }

  const fixedConservatories = getFixedConservatories(alias);
  const freeConservatories = getFreeConservatories(alias);

  return (
    <>
      <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 3}}>
        <Typography variant="h1">{getSeasonName(alias, Uterum.Season)}</Typography>
      </Box>

      <Typography variant="h2" sx={{textAlign: 'center', mb: 2}}>{alias.bfcModelTypeFixed}</Typography>
      <Grid container spacing={{ xs: 3, lg: 4 }} mb={{ xs: 6, md: 7, lg: 8 }}>
        {listConservatories(fixedConservatories)}
      </Grid>

      <Typography variant="h2" sx={{textAlign: 'center', mb: 2}}>{alias.bfcModelTypeFree}</Typography>
      <Grid container spacing={{xs: 3, lg: 4}}>
        {listConservatories(freeConservatories)}
      </Grid>

      {/* TODO: Make a reusauble ReactModal compponent that includes the close button */}
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        appElement={document.getElementById("bfc-single-page-app")}
        style={modalStyle}
      >
        <CloseButton onClick={closeModal} data-id="Tooltip__Modal__CloseButton">
          <Glyphicon name="circle-remove" />
        </CloseButton>
        <InspirationHeader>
          {alias.bfcInspirationHeader} {inspirationUterum.name}
        </InspirationHeader>
        <>
          {alias.hasOwnProperty(inspirationUterum.imagelistAlias) ? (
            <InspirationImageContainer
              dangerouslySetInnerHTML={{
                __html: alias[inspirationUterum.imagelistAlias],
              }}
            ></InspirationImageContainer>
          ) : (
            <div>{`Missing imagelistAlias: ${inspirationUterum.imagelistAlias}`}</div>
          )}
        </>
      </ReactModal>
    </>
  );
};

export default ModelView;
